import { render, staticRenderFns } from "./CampanhasAniversario.vue?vue&type=template&id=7ad67655&scoped=true"
import script from "./CampanhasAniversario.vue?vue&type=script&lang=js"
export * from "./CampanhasAniversario.vue?vue&type=script&lang=js"
import style0 from "./CampanhasAniversario.vue?vue&type=style&index=0&id=7ad67655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad67655",
  null
  
)

export default component.exports